// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export const locales = [
  {
    "id": "zh-CN",
    "name": "中文",
    "base": "/"
  }
];
export const messages = {
  "en-US": {
    "header.search.placeholder": "Type keywords...",
    "header.color.mode.light": "Light Mode",
    "header.color.mode.dark": "Dark Mode",
    "header.color.mode.auto": "Follow System",
    "header.social.github": "GitHub",
    "header.social.weibo": "Weibo",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "Zhihu",
    "header.social.yuque": "Yuque",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "Show Code",
    "previewer.actions.code.shrink": "Hide Code",
    "previewer.actions.code.editable": "Edit code with real-time preview",
    "previewer.actions.code.readonly": "Only index file is editable",
    "previewer.actions.sketch": "Copy to Sketch app",
    "previewer.actions.sketch.group": "Copy as Sketch Group",
    "previewer.actions.sketch.symbol": "Copy as Sketch Symbol",
    "previewer.actions.sketch.divider": "------------------------",
    "previewer.actions.sketch.guide": "How to paste to Sketch?",
    "previewer.actions.codesandbox": "Open in CodeSandbox",
    "previewer.actions.codepen": "Open in CodePen (Not implemented)",
    "previewer.actions.stackblitz": "Open in StackBlitz",
    "previewer.actions.separate": "Open in separate page",
    "404.title": "PAGE NOT FOUND",
    "404.back": "Back to homepage",
    "api.component.name": "Name",
    "api.component.description": "Description",
    "api.component.type": "Type",
    "api.component.default": "Default",
    "api.component.required": "(required)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "Experimental",
    "api.component.release.deprecated": "Deprecated",
    "api.component.unavailable": "apiParser must be enabled to use auto-generated API",
    "api.component.loading": "Properties definition is resolving, wait a moment...",
    "api.component.not.found": "Properties definition not found for {id} component",
    "content.tabs.default": "Doc",
    "content.footer.last.updated": "Last updated: ",
    "content.footer.actions.edit": "Improve this documentation",
    "content.footer.actions.previous": "PREV",
    "content.footer.actions.next": "NEXT",
    "search.not.found": "No content was found",
    "search.loading": "Loading...",
    "layout.sidebar.btn": "Sidebar",
    "app.not-found.back-home": "Back to home page",
    "app.not-found.subTitle": "Sorry, the page you visited does not exist.",
    "app.theme.switch.dark": "Dark theme",
    "app.theme.switch.compact": "Compact theme",
    "app.header.menu.more": "More",
    "app.footer.last.updated": "Last updated: ",
    "app.footer.actions.edit": "Improve this documentation"
  },
  "zh-CN": {
    "header.search.placeholder": "输入关键字搜索...",
    "header.color.mode.light": "亮色模式",
    "header.color.mode.dark": "暗色模式",
    "header.color.mode.auto": "跟随系统",
    "header.social.github": "GitHub",
    "header.social.weibo": "微博",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "知乎",
    "header.social.yuque": "语雀",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "展开代码",
    "previewer.actions.code.shrink": "收起代码",
    "previewer.actions.code.editable": "编辑代码可实时预览",
    "previewer.actions.code.readonly": "仅 index 可编辑",
    "previewer.actions.codesandbox": "在 CodeSandbox 中打开",
    "previewer.actions.sketch": "拷贝到 Sketch",
    "previewer.actions.sketch.group": "拷贝为 Sketch Group",
    "previewer.actions.sketch.symbol": "拷贝为 Sketch Symbol",
    "previewer.actions.sketch.divider": "----------------------",
    "previewer.actions.sketch.guide": "如何粘贴到 SKetch？",
    "previewer.actions.stackblitz": "在 StackBlitz 中打开",
    "previewer.actions.separate": "在独立页面中打开",
    "404.title": "页面未找到",
    "404.back": "返回首页",
    "api.component.name": "属性名",
    "api.component.description": "描述",
    "api.component.type": "类型",
    "api.component.default": "默认值",
    "api.component.required": "(必选)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "实验性",
    "api.component.release.deprecated": "废弃",
    "api.component.unavailable": "必须启用 apiParser 才能使用自动 API 特性",
    "api.component.loading": "属性定义正在解析中，稍等片刻...",
    "api.component.not.found": "未找到 {id} 组件的属性定义",
    "content.tabs.default": "文档",
    "content.footer.last.updated": "最后更新时间：",
    "content.footer.actions.edit": "帮助改进此文档",
    "content.footer.actions.previous": "上一篇",
    "content.footer.actions.next": "下一篇",
    "search.not.found": "未找到相关内容",
    "search.loading": "加载中...",
    "layout.sidebar.btn": "侧边菜单",
    "app.not-found.back-home": "返回首页",
    "app.not-found.subTitle": "你访问的页面貌似不存在？",
    "app.theme.switch.dark": "暗黑主题",
    "app.theme.switch.compact": "紧凑主题",
    "app.header.menu.more": "更多",
    "app.footer.last.updated": "最后更新时间：",
    "app.footer.actions.edit": "帮助改进此文档"
  }
};
